module.exports = __webpack_public_path__ + "img/medlabo_top.9de0ce32.jpg";